var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import RcRate from 'rc-rate';
import omit from 'omit.js';
import StarFilled from '@ant-design/icons/StarFilled';
import Tooltip from '../tooltip';
import { ConfigContext } from '../config-provider';
const Rate = React.forwardRef((props, ref) => {
    const characterRender = (node, { index }) => {
        const { tooltips } = props;
        if (!tooltips)
            return node;
        return <Tooltip title={tooltips[index]}>{node}</Tooltip>;
    };
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const { prefixCls } = props, restProps = __rest(props, ["prefixCls"]);
    const rateProps = omit(restProps, ['tooltips']);
    const ratePrefixCls = getPrefixCls('rate', prefixCls);
    return (<RcRate ref={ref} characterRender={characterRender} {...rateProps} prefixCls={ratePrefixCls} direction={direction}/>);
});
Rate.displayName = 'Rate';
Rate.defaultProps = {
    character: <StarFilled />,
};
export default Rate;
